import { CheckBox } from '../CheckBox';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";
const styledContainer = {
  width: '20px',
  height: '20px',
  display: 'flex'
};
export const RowSelectHeaderCell = _ref => {
  let {
    onChange,
    checked,
    indeterminate
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    sx: styledContainer,
    className: 'ids-row-select-header-cell',
    children: /*#__PURE__*/_jsx(CheckBox, {
      value: '0',
      onChange: onChange,
      checked: checked,
      indeterminate: indeterminate
    })
  });
};